module.exports = __webpack_public_path__ + "static/media/flag.665b7d7a.svg";